import React from 'react';
import { BookIcon, CodeIcon, PuzzleIcon, TerminalIcon } from 'lucide-react';
export function DocsPage() {
  const sections = [{
    title: 'Getting Started',
    description: 'Learn the core concepts of MCPGuard and how to set up your first secure agentic workflow.',
    icon: <BookIcon className="h-6 w-6 text-[#4db8a4]" data-id="element-139" />
  }, {
    title: 'Architecture',
    description: 'Deep dive into the MCPGuard security plane, delegated authorization, and the context firewall.',
    icon: <PuzzleIcon className="h-6 w-6 text-[#4db8a4]" data-id="element-140" />
  }, {
    title: 'API Reference',
    description: 'Complete documentation for the MCPGuard API, including authentication, policy management, and audit logs.',
    icon: <CodeIcon className="h-6 w-6 text-[#4db8a4]" data-id="element-141" />
  }, {
    title: 'CLI Tool',
    description: 'Manage policies, inspect audit trails, and configure integrations directly from your terminal.',
    icon: <TerminalIcon className="h-6 w-6 text-[#4db8a4]" data-id="element-142" />
  }];
  return <div className="w-full max-w-5xl mx-auto py-12 px-4 animate-in fade-in duration-500" data-id="element-143">
      <div className="mb-12" data-id="element-144">
        <h1 className="text-4xl font-bold text-[#1e3a5f] mb-4" data-id="element-145">
          Documentation
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl" data-id="element-146">
          Everything you need to build secure, auditable AI agent workflows with
          MCPGuard.
        </p>
      </div>

      <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 mb-12" data-id="element-147">
        <h2 className="text-lg font-bold text-amber-900 mb-2" data-id="element-148">
          Documentation Coming Soon
        </h2>
        <p className="text-amber-800" data-id="element-149">
          MCPGuard is currently in private preview. Full technical documentation
          will be available to waitlist members upon access.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6" data-id="element-150">
        {sections.map((section, index) => <div key={index} className="border border-gray-200 rounded-xl p-6 opacity-50 cursor-not-allowed select-none" data-id="element-151">
            <div className="flex items-start gap-4" data-id="element-152">
              <div className="h-12 w-12 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-153">
                {section.icon}
              </div>
              <div data-id="element-154">
                <div className="flex items-center gap-2 mb-2" data-id="element-155">
                  <h3 className="text-xl font-bold text-gray-400" data-id="element-156">
                    {section.title}
                  </h3>
                  <span className="text-xs font-medium bg-gray-100 text-gray-400 px-2 py-0.5 rounded-full" data-id="element-157">
                    Coming soon
                  </span>
                </div>
                <p className="text-gray-400 leading-relaxed" data-id="element-158">
                  {section.description}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}